module.exports = __webpack_public_path__ + "static/img/stay-option-icon-song.9089ebc9.svg";